import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'antd';
import { FormField, RadioGroup, Tooltip } from 'components';
import { updateFormField } from 'store/forms/actions';
import { formFields2_1, formFields2_2 } from './formFields';
import { useDispatch, useSelector } from 'react-redux';
import { get, omit, update, isNil, isEmpty } from 'lodash';
import moment from 'moment';
import { useForm } from 'antd/lib/form/Form';
import { formattedNumber, getFullDate , isBeneficiary } from 'utils';
import SorefsisChart from '../sorefsisChart';
import Sorefsis from 'components/sorefsis';


const CompanyDetails = () => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const carrier = useSelector(state => state.forms.carrier);
  const user = useSelector(state => state.user);
  const task = useSelector(state => state.forms.task);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || !isBeneficiary(user.groups);
  const totalAmountSorefsis = useSelector(
    state => state.forms.carrier.totalAmountSorefsis
  );
  const [abiPerfectureOptions, setAbiPerfectureOptions] = useState([]);
  const [abiDistrictOptions, setAbiDistrictOptions] = useState([]);
  const [tkOptions, setTkOptions] = useState([]);
  const mainKAD = useSelector(state => state.forms.carrier.mainKAD);
  const businessPlanAssets = useSelector(state => state.forms?.businessPlanDetails?.businessPlanAssets)

  const handleChange = ({ key, type, event }) => {
    let newValue;
    if (type === 'text' || type === 'textarea' || type === 'radio') {
      newValue = event.target.value;
    } else if (type === 'date') {
      newValue = new Date(event).toLocaleDateString();
    } else if (type === 'checkbox') {
      newValue = event.target.checked;
    } else if (
      type === 'select' ||
      type === 'number' ||
      type === 'numberWithDecimals'
    ) {
      newValue = event;
    }

    dispatch(
      updateFormField({
        group: 'carrier',
        key,
        value: newValue,
      })
    );
  };

  useEffect(() => {
    if (user.taxis_data) {
      setTkOptions(user.taxis_data?.tks?.map(item => ({
        label: item.code,
        value: item.code,
      })))
      return Promise.all([
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'companyName',
            value: !isNil(user.taxis_data?.onomasia)
              ? user.taxis_data?.onomasia
                  .split(',')
                  .join(' ')
                  .split('  ')
                  .join(' ')
              : carrier.companyName,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'abiVat',
            value: !isNil(user.taxis_data?.afmTrimmed)
              ? user.taxis_data?.afmTrimmed
              : carrier.abiVat, //user.taxis_data?.afmTrimmed,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'regDate',
            value: !isNil(user.taxis_data?.registDate)
              ? getFullDate(user.taxis_data?.registDate)
              : carrier.regDate,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'abiStreetFull',
            value:
              !isNil(user.taxis_data?.firmAddress) &&
              !isNil(user.taxis_data?.firmAddressNo)
                ? user.taxis_data?.firmAddress +
                  ' ' +
                  user.taxis_data?.firmAddressNo
                : carrier.abiStreetFull,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'abiTk',
            value: carrier?.abiTk
            //  ? 
            //   carrier.abiTk 
            //   :
            // !isNil(user.taxis_data?.tks)
            // ? user.taxis_data?.tks?.map(item => ({
            //   label: item.code,
            //   value: item.code,
            // }))
            // : carrier.abiTk,
          })
        ),
        // dispatch(
        //   updateFormField({
        //     group: 'carrier',
        //     key: 'abiPerfecture',
        //     value:
        //       !isNil(user.taxis_data?.tks) &&
        //       !isNil(user.taxis_data?.tks[0].nomos)
        //         ? user.taxis_data?.tks[0].nomos
        //         : carrier.abiPerfecture,
        //   })
        // ),
        // dispatch(
        //   updateFormField({
        //     group: 'carrier',
        //     key: 'abiDistrict',
        //     value: !isNil(user.taxis_data?.firmParDescr)
        //       ? user.taxis_data?.firmParDescr
        //       : carrier.abiDistrict,
        //   })
        // ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'invMob',
            value: !isNil(user.taxis_data?.firmPhone)
              ? user.taxis_data?.firmPhone
              : carrier.invMob,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'mainKAD',
            value: !isNil(user.taxis_data?.mainKadCode)
              ? user.taxis_data?.mainKadCode
              : carrier.mainKAD,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'mainKADDescription',
            value: !isNil(user.taxis_data?.mainKadDescription)
              ? user.taxis_data?.mainKadDescription
              : carrier.mainKADDescription,
          })
        ),
        dispatch(
          updateFormField({
            group: 'carrier',
            key: 'companySize',
            value: isNil(carrier.companySize) ? "Μικρή" : carrier.companySize,
          })
        ),
      ]);
    }
  }, [user.taxis_data]);


  useEffect(() => {
    if(isNil(carrier?.abiTk) && user.taxis_data?.tks?.length == 1) {
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiTk',
          value: !isNil(user.taxis_data?.firmZipCode)
          ? user.taxis_data?.firmZipCode
          : carrier.abiTk,
        })
      )
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiPerfecture',
          value:
            !isNil(user.taxis_data?.tks) &&
            !isNil(user.taxis_data?.tks[0].nomos)
              ? user.taxis_data?.tks[0].nomos
              : carrier.abiPerfecture,
        })
      )
      dispatch(
        updateFormField({
          group: 'carrier',
          key: 'abiDistrict',
          value: !isNil(user.taxis_data?.firmParDescr)
            ? user.taxis_data?.firmParDescr
            : carrier.abiDistrict,
        })
      )
    }
  } ,[user.taxis_data, tkOptions])

  useEffect(() => {
    form.setFieldsValue({
      companyName: carrier.companyName,
      abiVat: carrier.abiVat,
      regDate: carrier.regDate,
      abiStreetFull: carrier.abiStreetFull,
      abiTk: carrier.abiTk,
      abiPerfecture: carrier.abiPerfecture,
      abiDistrict: carrier.abiDistrict,
      invMob: carrier.invMob,
      mainKAD: carrier.mainKAD +' - ' + carrier.mainKADDescription,
      companySize: carrier.companySize,
      website: carrier.website,
      companyLegalType: carrier.companyLegalType,
      invMail: carrier.invMail,
    });
  }, [form, carrier]);

  const renderFieldValue = field => {
    const value = get(carrier, field.name, '');
    return field.type === 'date' ? (value ? moment(value) : '') : value;
  };

  useEffect(() => {
    dispatch(
      updateFormField({
        group: 'carrier',
        key: 'publicExpPerc',
        value: carrier.companySize == 'Μικρή' ? parseFloat(0.5) : carrier.companySize == 'Μεσαία' ? parseFloat(0.4) : parseFloat(0.3),
      })
    );
  },[carrier.companySize])

  useEffect(() => {

    if(!isNil(businessPlanAssets)) {
      const newExpenses = [...businessPlanAssets];
      businessPlanAssets.forEach((item,index) => {
      const newPublicExp = ''
      newExpenses[index] = {
        ...newExpenses[index],
        ['publicExp']: newPublicExp,
      };         
    })
    dispatch(
      updateFormField({
        group: 'businessPlanDetails',
        key: 'businessPlanAssets',
        value: newExpenses
      })
    );
    }

  },[carrier.publicExpPerc])

  useEffect(() => {
    if (tkOptions && user?.taxis_data?.tks) {
      const options = user?.taxis_data?.tks?.filter(item => item.code === carrier?.abiTk )
      .map(item => ({
        label: item.area,
        value: item.area,
      }));
      setAbiPerfectureOptions(options);
    }

    if (tkOptions && user?.taxis_data?.tks) {
      const options = user?.taxis_data?.tks?.filter(item => item.code === carrier?.abiTk )
      .map(item => ({
        label: item.nomos,
        value: item.nomos,
      }));
      setAbiDistrictOptions(options);
    }
  }, [carrier?.abiTk]);

  return (
    <div className="">
      <Form
        form={form}
        initialValues={{
          ...carrier,
        }}
        trigger="onChange"
      >
        <div className="carrier-data-form">
          <p className="mt-0 mr-0 color-blue-3 text-bold font-size-19">
          Στοιχεία Επιχείρησης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields2_1.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    value={renderFieldValue(field)}
                    validateFirst
                  >
                    <FormField
                      key={index}
                      disabled={field?.disabled || viewMode}
                      {...omit(field, ['span', 'rules', 'offset'])}
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
        <div className="carrier-data-form carrier-data-form__right">
          <p className="mt-0 mr-0 color-blue-3 text-bold font-size-19">
            Διεύθυνση Έδρας Επιχείρησης
          </p>
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            className="carrier-data-form__row"
          >
            {formFields2_2.map((field, index) => {
              return (
                <Col key={index} className="gutter-row" span={field.span}>
                  <Form.Item
                    name={[field.name]}
                    rules={field.rules}
                    validateFirst
                    value={renderFieldValue(field)}
                  >
                    <FormField
                      key={index}
                      disabled={viewMode
                        || ((field.name == 'abiTk' || field.name == 'abiPerfecture' || field.name == 'abiDistrict') && tkOptions?.length == 1)}
                      {...omit(field, ['span', 'rules'])}
                      options={
                        field.name === 'abiPerfecture'
                          ? abiPerfectureOptions
                          : field.name === 'abiDistrict'
                          ? abiDistrictOptions
                          : field.name === 'abiTk'
                          ? tkOptions
                          : ''
                      }
                      onChange={value =>
                        handleChange({
                          key: field.name,
                          type: field.type,
                          event: value,
                        })
                      }
                    />
                  </Form.Item>
                </Col>
              );
            })}
          </Row>
        </div>
      </Form>
      
      {/* <Row
        gutter={{ xs: 0, sm: 2, md: 5, lg: 10 }}
        className="carrier-data-form__row mt-6 sorefsis"
      >
        <Col span={20} className="sorefsis-col-1">
          <>
            <Sorefsis></Sorefsis>
          </>
        </Col>
        <Col span={4} className="sorefsis-col-2">
          <div className="mt-1">
            <SorefsisChart
              realValue={totalAmountSorefsis ? totalAmountSorefsis : 0}
              limit={mainKAD?.startsWith("01") ? process.env.REACT_APP_SOREFSIS_AMOUNT_KAD_01 : process.env.REACT_APP_SOREFSIS_AMOUNT }
            />
          </div>
          <div>
            {!viewMode && totalAmountSorefsis > (mainKAD?.startsWith("01") ? process.env.REACT_APP_SOREFSIS_AMOUNT_KAD_01 : process.env.REACT_APP_SOREFSIS_AMOUNT) && (
              <div
                role="alert"
                className="ant-form-item-explain-error mt-0 mb-2"
              >
                Το Σύνολο Σώρευσης έχει υπερβεί το Όριο Deminimis κατά{' '}
                {formattedNumber(totalAmountSorefsis - (mainKAD?.startsWith("01") ? process.env.REACT_APP_SOREFSIS_AMOUNT_KAD_01 : process.env.REACT_APP_SOREFSIS_AMOUNT))}€
              </div>
            )}
          </div>
        </Col>
      </Row> */}
    </div>
  );
};

export default CompanyDetails;
